const WinlosesTypes = {
    FETCH_START:    '[FOOD][WINLOSES] FETCH START',
    FETCH_SUCCESS:  '[FOOD][WINLOSES] FETCH SUCCESS',
    FETCH_FAILURE:  '[FOOD][WINLOSES] FETCH FAILURE'
};

export default WinlosesTypes;